import ModalSlider from './modal-slider';

class ModalTeam {
	constructor(el) {
		this.el = el;
		this.container = this.el.closest('.block-team__cards');
		this.cards = Array.from(
			this.container.querySelectorAll('.js__modal--team')
		);

		this.currentCard = this.el;
		this.syncUrl = this.container.dataset.syncUrl === 'true';
        this.archiveUrl = this.container.dataset.archiveUrl;

		this.initialize();
	}

	get template() {
		return this.currentCard.querySelector('.block-team__modal-template');
	}

	get slug() {
		return this.currentCard.dataset.teamSlug || '';
	}

	get currentIndex() {
		return this.cards.indexOf(this.currentCard);
	}

	getCard(offset = 0) {
		return this.cards[this.currentIndex + offset] ?? null;
	}

	initialize = () => {
		this.el.addEventListener('click', () => {
			this.currentCard = this.el;
			this.open();
		});

        // Automatically open the requested team member on archive pages.
		if (this.el.classList.contains('is-requested')) {
			this.currentCard = this.el;
			this.open();
		}
	};

	open() {
		if (!this.template) {
			return;
		}

		if (this.syncUrl) {
			this.updateUrl();
		}

		ModalSlider.show(this.template.innerHTML, {
			callbacks: {
				onPrevious: () => this.previous(),

				onNext: () => this.next(),

				onHide: () => {
					if (this.syncUrl) {
						this.resetUrl();
					}
				}
			}
		});

		this.updateButtons();
	}

    // Refresh the modal content when navigating between team members.
	render() {
		if (!this.template) {
			return;
		}

		ModalSlider.setContent(this.template.innerHTML);

		if (this.syncUrl) {
			this.updateUrl();
		}

		this.updateButtons();
	}

	updateButtons() {
		ModalSlider.setPreviousDisabled(!this.getCard(-1));
		ModalSlider.setNextDisabled(!this.getCard(1));
	}

	previous() {
		const previousCard = this.getCard(-1);

		if (!previousCard) {
			return;
		}

		this.currentCard = previousCard;

		this.render();
	}

	next() {
		const nextCard = this.getCard(1);

		if (!nextCard) {
			return;
		}

		this.currentCard = nextCard;

		this.render();
	}

    // Keep the URL in sync with the currently displayed team member.
	updateUrl() {
		if (!this.slug) {
			return;
		}

		window.history.pushState(
			{},
			'',
			`${this.archiveUrl}${this.slug}/`
		);
	}

	resetUrl() {
		window.history.pushState(
			{},
			'',
			this.archiveUrl
		);
	}
}

export default ModalTeam;